import { Inquiry } from './../models/inquiry.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class InquiryService {
  baseUrl = `${environment.apiUrl}/inquiries`;

  constructor(private http: HttpClient) {}

  getAll(categoryName: string, isAdmin: boolean = false): Observable<Inquiry[]> {
    const params = new HttpParams().set('category', categoryName).set('isAdmin', String(isAdmin));
    return this.http.get<Inquiry[]>(this.baseUrl, { params });
  }

  getAllByUserId(categoryName: string, user_id: number, isAdmin: boolean = false): Observable<Inquiry[]> {
    const params = new HttpParams().set('category', categoryName).append('user_id', user_id).set('isAdmin', String(isAdmin));
    return this.http.get<Inquiry[]>(this.baseUrl, { params });
  }

  get(id: number, isAdmin: boolean = false): Observable<Inquiry> {
    const params = new HttpParams().set('isAdmin', String(isAdmin));
    return this.http.get<Inquiry>(`${this.baseUrl}/${id}`, { params });
  }

  uploadWithFile(formData: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}`, formData);
  }

  addChild(inquiryId: number, payload: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/${inquiryId}/children`, payload);
  }

  downloadAttachment(id: number): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.baseUrl}/attachments/${id}`, {
      observe: 'response',          // headers も取得するため
      responseType: 'blob'          // 本体はバイナリ
    });
  }

  markAsCompleted(id: number): Observable<any> {
    return this.http.patch(`${this.baseUrl}/${id}/complete`, {});
  }

  markAsCanceled(id: number): Observable<any> {
    return this.http.patch(`${this.baseUrl}/${id}/cancel`, {});
  }

  update(id: number, payload: { status: string; priority: string }): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}`, payload);
  }
}
